(() => {
  'use strict';
  function init(scope) {
    scope.querySelectorAll('[data-mg-comparison]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true'; root.classList.add('enhanced');
      const search = root.querySelector('[data-search]');
      const upgrades = root.querySelector('[data-upgrades]');
      const rows = [...root.querySelectorAll('details[data-topic]')];
      const expand = root.querySelector('[data-expand]');
      const filters = [...root.querySelectorAll('[data-family]')];
      let family = 'All';
      function refresh() {
        const q = search.value.trim().toLowerCase();
        rows.forEach(row => { row.hidden = !((family === 'All' || row.dataset.category === family) && (!upgrades.checked || row.dataset.upgrade === 'true') && (!q || row.dataset.search.includes(q))); });
        const visible = rows.filter(row => !row.hidden);
        root.querySelector('[data-count]').textContent = `${visible.length} of ${rows.length} topics`;
        root.querySelector('[data-empty]').hidden = visible.length > 0;
        expand.disabled = visible.length === 0;
        expand.textContent = visible.length && visible.every(row => row.open) ? 'Collapse all' : 'Expand all';
      }
      search.addEventListener('input', refresh); upgrades.addEventListener('change', refresh);
      filters.forEach(button => button.addEventListener('click', () => {
        family = button.dataset.family;
        filters.forEach(b => b.setAttribute('aria-pressed', String(b === button))); refresh();
      }));
      expand.addEventListener('click', () => { const visible = rows.filter(row => !row.hidden); const open = !visible.every(row => row.open); visible.forEach(row => row.open = open); refresh(); });
      rows.forEach(row => row.addEventListener('toggle', refresh));
      root.querySelector('[data-reset]').addEventListener('click', () => {
        family = 'All'; search.value = ''; upgrades.checked = false;
        filters.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.family === 'All'))); refresh(); search.focus();
      });
      refresh();
    });
    scope.querySelectorAll('[data-mg-walkthrough]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true'; root.classList.add('enhanced');
      const panels = [...root.querySelectorAll('[data-panel]')];
      const tabs = [...root.querySelectorAll('[data-select-panel]')];
      tabs.forEach(tab => { tab.id = tab.getAttribute('aria-controls') + '-tab'; });
      panels.forEach(panel => { panel.setAttribute('role', 'tabpanel'); panel.setAttribute('aria-labelledby', panel.id + '-tab'); });
      const requested = new URLSearchParams(location.search).get('panel');
      let key = requested === 'maxfunction' ? 'maxfunction' : 'works';
      let step = 0;
      function refresh(focusTitle = false) {
        panels.forEach(panel => {
          panel.classList.add('enhanced-panel'); panel.hidden = panel.dataset.panel !== key;
          panel.querySelectorAll('[data-lesson]').forEach(lesson => lesson.hidden = Number(lesson.dataset.lesson) !== step);
          panel.querySelectorAll('[data-step]').forEach(button => {
            if (Number(button.dataset.step) === step) button.setAttribute('aria-current', 'step'); else button.removeAttribute('aria-current');
          });
          panel.querySelector('[data-previous]').disabled = step === 0;
          panel.querySelector('[data-next]').textContent = ['See the connections →','Read an explained result →','Find your next steps →','Start again ↻'][step];
          panel.querySelector('[data-progress]').textContent = `${step + 1} / 4`;
        });
        tabs.forEach(tab => { const selected = tab.dataset.selectPanel === key; tab.setAttribute('aria-selected', String(selected)); tab.tabIndex = selected ? 0 : -1; });
        root.querySelector('[data-panel-announcement]').textContent = `${key === 'works' ? 'The Works' : 'MaxFunction'}, step ${step + 1} of 4`;
        if (focusTitle) root.querySelector(`[data-panel="${key}"] [data-lesson="${step}"] h2`).focus();
      }
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => { key = tab.dataset.selectPanel; refresh(); });
        tab.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault(); const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          key = tabs[next].dataset.selectPanel; refresh(); tabs[next].focus();
        });
      });
      panels.forEach(panel => {
        panel.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => { step = Number(button.dataset.step); refresh(true); }));
        panel.querySelector('[data-previous]').addEventListener('click', () => { step = Math.max(0, step - 1); refresh(true); });
        panel.querySelector('[data-next]').addEventListener('click', () => { step = (step + 1) % 4; refresh(true); });
      });
      refresh();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
